import React from 'react';
import { Grid, Typography } from '@mui/material';
import { IPayBonusSectionProps } from 'app/models/Orders/OrderDetails';
import { useStyles } from './OrderDetailsReportStyles';
import { useTranslation } from 'react-i18next';
import { AMNDivisionType } from 'app/models/enums/AMNDivisionType';

type PayBonusSectionProps = {
  payandbonusDetails: IPayBonusSectionProps;
};
export const OrderDetailsReportPayBonusInfo = (props: PayBonusSectionProps) => {
  const { classes } = useStyles();
  const paybonusDetails = props.payandbonusDetails;
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid container className={classes.dataCell}>
        <Typography>{t('order.orderReportDetails.paybonusSection.bonusheader')}</Typography>
      </Grid>

      <Grid container>
        <Grid container className={`${classes.gridLabel}`}>
          <Grid xs={12} md={1}>
            <Typography>{t('order.orderReportDetails.paybonusSection.skillset')}</Typography>
          </Grid>
          <Grid xs={12} md={1}>
            <Typography>{t('order.orderReportDetails.paybonusSection.payer')}</Typography>
          </Grid>
          <Grid xs={12} md={0.7}>
            <Typography>{t('order.orderReportDetails.paybonusSection.shift')}</Typography>
          </Grid>
          <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.paybonusSection.weeklygross')}</Typography>
          </Grid>
          <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.paybonusSection.regular')}</Typography>
          </Grid>
          <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.paybonusSection.composite')}</Typography>
          </Grid>
          <Grid xs={12} md={1.3} className={`${classes.gridrightAlign}`}>
            <Grid container>
              <Grid xs={12} md={6}>
                <Typography>{t('order.orderReportDetails.paybonusSection.ot')}</Typography>
              </Grid>
              <Grid xs={12} md={6}>
                <Typography>{t('order.orderReportDetails.paybonusSection.dt')}</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.paybonusSection.holiday')}</Typography>
          </Grid>
          <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.paybonusSection.oncall')}</Typography>
          </Grid>
          <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.paybonusSection.callback')}</Typography>
          </Grid>
          <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.paybonusSection.paysgww')}</Typography>
          </Grid>
          <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
            <Typography>{t('order.orderReportDetails.paybonusSection.charge')}</Typography>
          </Grid>
        </Grid>
        {paybonusDetails.payRates.map((row, index) => (
          <Grid container className={`${classes.gridData}`} key={index}>
            <Grid xs={12} md={1}>
              {row.skillset}
            </Grid>
            <Grid xs={12} md={1}>
              {row.payroll}
            </Grid>
            <Grid xs={12} md={0.7}>
              {row.descShift}
            </Grid>
            <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
              {row.takeHomeRate}
            </Grid>
            <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
              {row.regularRate}
            </Grid>
            <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
              {row.compositeRate}
            </Grid>
            <Grid xs={12} md={1.3} className={`${classes.gridrightAlign}`}>
              <Grid container>
                <Grid xs={12} md={6}>
                  {row.overtimeFactor}
                </Grid>
                <Grid xs={12} md={6}>
                  {row.doubletimeFactor}
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
              {row.holidayRate}
            </Grid>
            <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
              {row.onCallRate}
            </Grid>
            <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
              {row.callbackRate}
            </Grid>
            <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
              {row.paysGWW}
            </Grid>
            <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
              {row.chargePremium}
            </Grid>

            
              <Grid xs={6} md={3} className={classes.gridLabel}>
                {t('order.orderReportDetails.paybonusSection.additionalpremiumpay')}
              </Grid>
              <Grid xs={6} md={9} className={`${classes.dataCell}`}>
                {row.additionalPremiumPay}
              </Grid>
                                                                                                                                    </Grid>
        ))}
      </Grid>

      <Grid container className={classes.headlabel}>
        <Grid xs={6} md={6}>
          {t('order.orderReportDetails.paybonusSection.shiftdifferentials')}
        </Grid>

        <Grid xs={6} md={6}>
          {t('order.orderReportDetails.paybonusSection.paycycle')}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={5.5}>
          <Grid container className={`${classes.gridLabel}`}>
            <Grid item xs={6} md={3}>
              <Typography>{t('order.orderReportDetails.paybonusSection.skillset')}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography>{t('order.orderReportDetails.paybonusSection.description')}</Typography>
            </Grid>
            <Grid item xs={6} md={2}>
              <Typography>{t('order.orderReportDetails.paybonusSection.amount')}</Typography>
            </Grid>
            <Grid item xs={6} md={2}>
              <Typography>{t('order.orderReportDetails.paybonusSection.shiftstart')}</Typography>
            </Grid>
            <Grid item xs={6} md={2}>
              <Typography>{t('order.orderReportDetails.paybonusSection.shiftend')}</Typography>
            </Grid>
          </Grid>
          {paybonusDetails.pPShiftDifferentials.map((row, index) => (
            <Grid container className={`${classes.gridData}`} key={index}>
              <Grid item xs={6} md={3}>
                {row.skillset}
              </Grid>
              <Grid item xs={6} md={3}>
                {row.descShiftDifferentialDescriptionType}
              </Grid>
              <Grid item xs={6} md={2}>
                {row.amount}
              </Grid>
              <Grid item xs={6} md={2}>
                {row.startTime}
              </Grid>
              <Grid item xs={6} md={2}>
                {row.endTime}
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Grid xs={6} md={0.5}></Grid>
        <Grid xs={6} md={6}>
          <Grid container>
            <Grid container style={{marginBottom:20}}>
              <Grid container className={`${classes.gridLabel}`}>
                <Grid item xs={6} md={2}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.type')}</Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.shift')}</Typography>
                </Grid>
                <Grid item xs={6} md={3.5}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.start')}</Typography>
                </Grid>
                <Grid item xs={6} md={3.5}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.end')}</Typography>
                </Grid>
              </Grid>
              {paybonusDetails.facilityPpPayCyle.map((row, index) => (
                <Grid container className={`${classes.gridData}`} key={index}>
                  <Grid item xs={6} md={2}>
                    {row.descPayCycleType}
                  </Grid>
                  <Grid item xs={6} md={3}>
                    {row.descShiftType}
                  </Grid>
                  <Grid item xs={6} md={3.5}>
                    {row.descStartDay}
                  </Grid>
                  <Grid item xs={6} md={3.5}>
                    {row.descEndDay}
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid xs={6} md={5} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.timecardtype')}:</Typography>
            </Grid>
            <Grid xs={6} md={7} className={`${classes.dataCell}`}>
              {paybonusDetails.descTimecardType}
            </Grid>

            <Grid xs={6} md={5} className={`${classes.alternativeLabelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.timesubmittedby')}:</Typography>
            </Grid>
            <Grid xs={6} md={7} className={`${classes.alternativeDataCell}`}>
              {paybonusDetails.descTimeSubmittedBY}
            </Grid>

            <Grid xs={6} md={5} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.carrentalreimbursement')}:</Typography>
            </Grid>
            <Grid xs={6} md={7} className={`${classes.dataCell}`}>
              {paybonusDetails.carRental}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={6} md={2} className={classes.alternativeLabelCell}>
          <Typography>{t('order.orderReportDetails.paybonusSection.notes')}:</Typography>
        </Grid>
        <Grid item xs={6} md={10} className={classes.alternativeDataCell}>
          {paybonusDetails.notes?.split('\n').length > 1
            ? paybonusDetails.notes?.split('\n').map(str => <Typography>{str}</Typography>)
            : paybonusDetails.notes}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={6} md={2} className={`${classes.labelCell}`} >
          <Typography>{t('order.orderReportDetails.paybonusSection.facilityPPGWWExceptions')}:</Typography>
        </Grid>
        <Grid item xs={6} md={10} className={`${classes.dataCell}`}>
                  {paybonusDetails.facilityPPGWWExceptions}
        </Grid>
      </Grid>
      {paybonusDetails.amnDivisionTypeId==AMNDivisionType.InDemand &&(
          <Grid container>
          <Grid container>
            <Grid xs={6} md={7} className={classes.headlabel}>
              {t('order.orderReportDetails.paybonusSection.guaranteedworkweek')}
            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={6} md={5.5}>
              <Grid container className={`${classes.gridLabel}`}>
                <Grid item xs={6} md={1}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.shift')}</Typography>
                </Grid>
                <Grid item xs={6} md={3} className={`${classes.gridrightAlign}`}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.minreqhrsweek')}</Typography>
                </Grid>
                <Grid item xs={6} md={1}></Grid>
                <Grid item xs={6} md={3}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.cxlhrsfreq')}</Typography>
                </Grid>
                <Grid item xs={6} md={2} className={`${classes.gridrightAlign}`}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.cxlhrs')}</Typography>
                </Grid>
              </Grid>
              {paybonusDetails.guaranteedWorkWeeks?.map((row, index) => (
                <Grid container className={`${classes.gridData}`} key={index}>
                  <Grid item xs={6} md={1}>
                    {row.shiftID}
                  </Grid>
                  <Grid item xs={6} md={3} className={`${classes.gridrightAlign}`}>
                    {row.hoursPerPayCycle}
                  </Grid>
                  <Grid item xs={6} md={1}></Grid>
                  <Grid item xs={6} md={3}>
                    {row.frequency}
                  </Grid>
                  <Grid item xs={6} md={2} className={`${classes.gridrightAlign}`}>
                    {row.cancellationHoursAllowed}
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <Grid xs={6} md={0.5}></Grid>
            <Grid xs={6} md={6}>
              <Grid container>
                <Grid xs={6} md={2} className={`${classes.labelCell}`}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.exception')}:</Typography>
                </Grid>
                <Grid xs={6} md={10} className={`${classes.dataCell}`}>
                  {paybonusDetails.guaranteedWorkWeeks[0]?.gwwException}
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container>
            <Grid xs={6} md={1} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.notes')}:</Typography>
            </Grid>
            <Grid xs={6} md={11} className={`${classes.dataCell}`}>
              {paybonusDetails.guaranteedWorkWeeks[0]?.gwwException?.split('\n').length > 1
                ? paybonusDetails.guaranteedWorkWeeks[0]?.gwwExceptionNotes
                    ?.split('\n')
                    .map(str => <Typography>{str}</Typography>)
                : paybonusDetails.guaranteedWorkWeeks[0]?.gwwExceptionNotes}
            </Grid>
          </Grid>
          </Grid>
      )}
      <Grid container className={classes.headlabel}>
        <Grid xs={6} md={6}>
          {t('order.orderReportDetails.paybonusSection.orderbonus')}
        </Grid>
      </Grid>

      {paybonusDetails.orderBonus.map((row, index) => (
        <Grid container key={index}>
          <Grid container>
            <Grid xs={6} md={2} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.type')}:</Typography>
            </Grid>
            <Grid xs={6} md={2} className={`${classes.dataCell}`}>
              {row.descBonusType}
            </Grid>
            <Grid xs={6} md={2} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.payer')}:</Typography>
            </Grid>
            <Grid xs={6} md={2} className={`${classes.dataCell} `}>
              {row.descPayer}
            </Grid>

            <Grid xs={6} md={2} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.shifts')}:</Typography>
            </Grid>
            <Grid xs={6} md={2} className={`${classes.dataCell}`}>
              {row.shifts}
            </Grid>
          </Grid>

          <Grid container>
            <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.amount')}:</Typography>
            </Grid>
            <Grid xs={6} md={2} className={`${classes.alternativeDataCell}`}>
              {row.bonusAmount}
            </Grid>
            <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.paymenttype')}:</Typography>
            </Grid>
            <Grid xs={6} md={2} className={`${classes.alternativeDataCell}`}>
              {row.descPaymentType}
            </Grid>
            <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.minimumweeksworked')}:</Typography>
            </Grid>
            <Grid xs={6} md={2} className={`${classes.alternativeDataCell} `}>
              {row.minimumWeeksWorked}
            </Grid>
          </Grid>

          <Grid container>
            <Grid xs={6} md={2} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.start')}:</Typography>
            </Grid>
            <Grid xs={6} md={2} className={`${classes.dataCell} `}>
              {row.startdate}
            </Grid>

            <Grid xs={6} md={2} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.shorthours')}:</Typography>
            </Grid>
            <Grid xs={6} md={2} className={`${classes.dataCell}`}>
              {row.descShortHoursType}
            </Grid>
            <Grid xs={6} md={2} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.paybonusSection.lessthan13weeks')}:</Typography>
            </Grid>
            <Grid xs={6} md={2} className={`${classes.dataCell}`}>
              {row.descSortAssignment}
            </Grid>
          </Grid>

          <Grid container>
            <Grid xs={6} md={12}>
              <Grid container>
                <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
                  <Typography>{t('order.orderReportDetails.paybonusSection.end')}:</Typography>
                </Grid>
                <Grid xs={6} md={10} className={`${classes.alternativeDataCell}`}>
                  {row.endDate}
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={6} md={2} className={`${classes.labelCell}`}>
                <Typography>{t('order.orderReportDetails.paybonusSection.notes')}:</Typography>
              </Grid>
              <Grid xs={6} md={10} className={`${classes.dataCell}`}>
                {row.notes?.split('\n').length > 1
                  ? row.notes?.split('\n').map(str => <Typography>{str}</Typography>)
                  : row.notes}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
